import axios from 'axios'

export const getAllBlock = (params) => {
  return axios.get('/blocks', {params: params})
}

export const createBlock = (data) => {
  return axios.post('/blocks', data)
}

export const deleteBlock = (id) => {
  return axios.delete('/blocks/' + id)
}



// WEBPACK FOOTER //
// ./src/api/block.js